import { render, staticRenderFns } from "./ProposalImage.vue?vue&type=template&id=06023d86"
import script from "./ProposalImage.vue?vue&type=script&lang=js"
export * from "./ProposalImage.vue?vue&type=script&lang=js"
import style0 from "./ProposalImage.vue?vue&type=style&index=0&id=06023d86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports